<template>
  <div class="assetTable">
    <slot-table :data="tableData" :columns="table.columns">
      <template slot="path" slot-scope="props">
         <div v-if="isEditMode">
            <a href="#" @click.prevent="selectFile(props.item.file)">
            <div v-if="props.item.asset_type === 'video'">
              <div class="asset__video" :video-url="props.item.path">
                 <video width="320" height="240" controls playsinline="true" :poster="assetUrl(props.item.thumb)" preload="none" controlslist="nodownload">
                  <source :src="assetUrl(props.item.path)" type="video/mp4">
                Your browser does not support the video tag.
                </video>
              </div>
            </div>
            <div v-else>
              <div class="asset__img">
                <img :src="assetUrl(props.item.path)" class="asset__img">
              </div>
            </div>
          </a>
         </div>
          <div v-else>
            <div v-if="props.item.asset_type === 'video'">
              <div class="asset__video" :video-url="props.item.path">
                <!--<img :src="assetUrl(props.item.thumb)" class="asset__img">-->
                <!--<span class="asset__video__play"><i class="fa fa-play"></i></span>-->
                <video width="320" height="240" controls playsinline="true" :poster="assetUrl(props.item.thumb)" preload="none" controlslist="nodownload">
                <source :src="assetUrl(props.item.path)" type="video/mp4">
              Your browser does not support the video tag.
              </video>
              </div>
            </div>
          <div v-else>
            <div class="asset__img">
                <img :src="assetUrl(props.item.path)" class="asset__img">
                <div id="imageCover"></div>
              </div>
            </div>
          </div>
      </template>

      <template slot="size" slot-scope="props">
        <span>
            {{ Number(props.item.size) | prettyBytes }}
        </span>
      </template>

      <template slot="actions" slot-scope="props">
        <span>
            <button  @click="deleteFile(props.item.file)" class="btn btn-xs btn-danger"><i class="fa fa-trash"></i> Delete</button>
        </span>
      </template>
      <!-- <template slot="pdf" slot-scope="props">
        <a v-if="props.item.download_url" :href="downloadUrl(props.item.download_url)" class="btn btn-primary btn-xs" target="_blank">
          <i class="fa fa-file-pdf-o"></i>
        </a>
        <router-link class="btn btn-warning btn-xs" :to="{ path: `/asset/full/${props.item.hash_id}` }">
          <i class="fa fa-file-text"></i>
        </router-link>
      </template> -->
    </slot-table>
  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {assetMixin} from '@/mixins/assetMixin'

import { API_URL } from '@/config'

export default {
  name: 'AssetTable',
  mixins: [assetMixin],
  components: {
    SlotTable,
    ButtonCta,
    Field,
    SwitchButton,
    Checkbox,
    Heading
  },
  props: {
    tableData: Array,
    confirmId: parent.confirmId
  },
  data: () => ({
    table: {
      columns: {
        path: 'Preview',
        file: 'Filename',
        width: 'Width (px)',
        height: 'Height (px)',
        mimetype: 'Mimetype',
        size: 'Size',
        actions: ''
      }
    }
  }),
  computed: {
    isEditMode: function () {
      return this.confirmId
    }
  },
  methods: {
    assetUrl (path) {
      return `${API_URL}${path.charAt(0) === '/' ? path.substring(1) : path}?ts=` + Math.round(+new Date() / 1000) // need to remove leading slash
    },
    deleteFile (file) {
      this.$emit('deleteFile', file)
    },
    previewFile (path) {
      window.open(path, '_blank')
    },
    selectFile (file) {
      this.$emit('selectFile', file)
    }
  }
}
</script>

<style lang="scss">
    .asset__img, .asset__video {
      background-color: #ccc;
      background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
      background-size: 10px 10px;
      background-position: 0 0, 5px 5px;
      padding: 0px;
      max-width: 200px;
      max-height: 200px;
      img, video {
        object-fit: scale-down;
        border:2px solid #000863;
      }
      & #imageCover {
        z-index:50;
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(123,123,123,0);
      }
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .asset__video {
      background-color: black;
      max-width: 320px;
      max-height: 320px;
    }
    .top-buffer {
      margin-top:10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AssetTable/asset-table.vue